import { QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from 'react-router-dom';
import { queryClient } from '@/shared/config/query-client';
import { ThemeProvider } from '@/shared/lib/theme';
import { BrandProvider } from '@/shared/lib/brand';
import { AuthProvider } from '@/shared/lib/auth';
import { TooltipProvider } from '@/shared/ui/tooltip';
import { Toaster } from '@/shared/ui/toaster';
import { CampaignDispatchNotifier } from '@/app/shell/campaign-dispatch-notifier';
import { ConfirmProvider } from '@/shared/components/confirm';
import { router } from '@/app/router';

export function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider>
        <BrandProvider>
          <TooltipProvider delayDuration={150} skipDelayDuration={250} disableHoverableContent={false}>
            <AuthProvider>
              <ConfirmProvider>
                <RouterProvider router={router} />
              </ConfirmProvider>
              <CampaignDispatchNotifier />
              <Toaster />
            </AuthProvider>
          </TooltipProvider>
        </BrandProvider>
      </ThemeProvider>
    </QueryClientProvider>
  );
}
